import { render, staticRenderFns } from "./CreateRvpRtoModal.vue?vue&type=template&id=2e89d6c2"
import script from "./CreateRvpRtoModal.vue?vue&type=script&lang=js"
export * from "./CreateRvpRtoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports